export const sessionStorageItems = {
  lastRefresh: 'last_refresh',
  graphStrokeColorKey: 'graph-stroke-color',
}
